export default {
    copyIndexes(state,data){        
        state.index = data
    }
}